import React from 'react';
import {Scrollbar, SurveyPagePropTypes} from '@ignitesales/neuro-application';
import {useBreakpoints} from "@ignitesales/neuro-application/src/neuro-ui/index.mjs";
import classnames from "classnames";

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {
    const { lg: isLargeScreen } = useBreakpoints();
    const ContainerWrapper = isLargeScreen ? Scrollbar : React.Fragment;
    const containerClasses = classnames(`${componentClass}__container`, {
        container: !isLargeScreen
    });

    return (
        <div className={className}>
            <div className={containerClasses}>
                <ContainerWrapper>
                    <div className={`questionGroups ${componentClass}__questionGroups`}>
                        { renderQuestionGroups() }
                    </div>
                </ContainerWrapper>
            </div>
        </div>
    );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;
